import type { ComponentType } from 'react';

interface DocumentPanelPlaceholderProps {
    icon: ComponentType<{ className?: string }>;
    message: string;
    tone?: 'muted' | 'error';
    onRetry?: () => void;
}

export function DocumentPanelPlaceholder({
    icon: Icon,
    message,
    tone = 'muted',
    onRetry
}: DocumentPanelPlaceholderProps) {
    const isError = tone === 'error';
    return (
        <div className="h-full flex flex-col items-center justify-center gap-3 p-8 text-center bg-white border border-gray-200 rounded-xl">
            <Icon className={`w-8 h-8 ${isError ? 'text-red-300' : 'text-gray-300'}`} />
            <div className={`text-sm ${isError ? 'text-red-600' : 'text-gray-500'}`}>{message}</div>
            {onRetry && (
                <button
                    type="button"
                    onClick={onRetry}
                    className="px-3 py-1.5 text-xs font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                >
                    Retry
                </button>
            )}
        </div>
    );
}
